import { ErrorCard, Errors } from '@commerce-webcomponents/ui';
import { useNextgenRouter } from '@nextgen-web-framework/all';
import Layout from 'app/components/Layout/Layout';
import { BasePageProps } from 'types/common';

const NotFound = (props: BasePageProps) => {
  const router = useNextgenRouter();
  const onActionClick = () => {
    router.push(`/`);
  };
  return (
    <Layout
      hasTopMobileHeader={false}
      header={props.data?.layout?.header}
      footer={props.data?.layout?.footer}
      hideNotifications={true}
    >
      <ErrorCard type={Errors.NotFound} onActionClick={onActionClick} />
    </Layout>
  );
};

export default NotFound;
